module.exports = __webpack_public_path__ + "img/exchangecnyline.2c162365.svg";